import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import GetProxy from "../../../../app/GetProxy";
import { handleResponseCode } from "../../../../app/utilities/helpers";
const cookies = new Cookies();
const proxy = GetProxy();

export const openVulnerabilityAPI = createAsyncThunk(
  "post/openVulnerabilityAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/report/api/v1/vm/getTotalFindingsCount`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const ClosedVmApplicationApi = createAsyncThunk(
  "post/ClosedmVApplicationApi",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/report/api/v1/vm/getClosedVulnerabilitiesFindingsCount`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const getVulnmanageTrendAPI = createAsyncThunk(
  "post/getVulnmanageTrendAPI",
  async (props) => {
    const { payload } = props;
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(`${proxy}/report/api/v1/vm/open/count`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
        body: JSON.stringify(payload),
      });
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const vulActionPlan = createAsyncThunk(
  "post/ActionPlan",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/report/api/v1/vm/getStatusBySeverity`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const vulOverviewTrend = createAsyncThunk(
  "post/OverviewTrend",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/report/api/v1/vm/vulnerabilityOverDueTrendChartData`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const vulTrendOnActualForecast = createAsyncThunk(
  "post/vulTrendOnActualForecast",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/report/api/v1/vm/trendOnActualForecast`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const serverTrendOnActualForecast = createAsyncThunk(
  "post/serverTrendOnActualForecast",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/report/api/v1/vm/getVulnerabilityOverviewTrendByIPBased`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const overDueVulnerabilityByPluginFamily = createAsyncThunk(
  "post/overDueVulnerabilityByPluginFamily",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/report/api/v1/vm/getPluginFamilyDetails`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const overDueVulnerabilityByType = createAsyncThunk(
  "post/overDueVulnerabilityByType",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/report/api/v1/vm/getOverdueVulnerabilityTypeDetails`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

const initialState = {
  openVulnerabiltyChartData: [],
  openVulnerabiltyChartloading: false,
  closedVmAppData: [],
  closedVmAppDataLoading: false,
  VulnTrendData: [],
  VulnTrendDataLoading: false,
  VulnOverviewTrendData: [],
  VulnOverviewTrendDataLoading: false,
  vulTrendOnActualForecastData: [],
  vulTrendOnActualForecastDataLoading: false,
  serverTrendOnActualForecastData: [],
  serverTrendOnActualForecastDataLoading: false,
  vulnerabilityByPluginFamilyData: [],
  vulnerabilityByPluginFamilyDataLoading: false,
  vulnerabilityByTypeData: [],
  vulnerabilityByTypeDataLoading: false,
  actionPlanChart: [],
  vulActionPlanloading: false,
  vulTrendOnActualForecastDataError: false,
  summaryDrillDownData: [],
  summaryDrillDownLoading: false,
  summaryDrillDownCount: 0,
  summaryFirstSeenDate: false,
  summaryFirstLoggedDate: false,
  summaryPluginDrillDownData: [],
  summaryPluginDrillDownLoading: false,
  overdueIpListData: [],
  overdueIpListDataLoading: false,
  error: false,
};
export const summaryDrillDownList = createAsyncThunk(
  "post/summaryDrillDownList",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload, pageNumber, itemsPerPage } = props;
      const response = await fetch(
        `${proxy}/report/api/v1/vm/trendOnActualForecast/drilldown/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Summary DrillDown API Error:", error);
      throw error;
    }
  }
);

export const getOverdueIpListByMonth = createAsyncThunk(
  "post/getOverdueIpListByMonth",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload, pageNumber = 0, itemsPerPage = 10 } = props;
      const response = await fetch(
        `${proxy}/report/api/v1/vm/getOverdueIpListByMonth/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const summaryPluginDrillDown = createAsyncThunk(
  "post/summaryPluginDrillDown",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { scanId, pluginId, ip } = props;
      const response = await fetch(
        `${proxy}/report/api/v1/vm/getPluginIdDetails/${scanId}/${pluginId}/${ip}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Summary Plugin DrillDown API Error:", error);
      throw error;
    }
  }
);

export const summarySlice = createSlice({
  name: "vmSlice",
  initialState,

  reducers: {
    resetVulnerabilityData: () => {
      return initialState;
    },
    setDisabledCategories: (state, action) => {
      state.disabledCategories = action.payload;
    },
    resetPluginDrillDown: (state) => {
      state.summaryPluginDrillDownData = [];
      state.summaryPluginDrillDownLoading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(openVulnerabilityAPI.pending, (state, action) => {
        state.openVulnerabiltyChartloading = true;
      })
      .addCase(openVulnerabilityAPI.fulfilled, (state, action) => {
        state.openVulnerabiltyChartData = action.payload;
        state.openVulnerabiltyChartloading = false;
      })
      .addCase(openVulnerabilityAPI.rejected, (state, action) => {
        state.openVulnerabiltyChartData = [];
        state.openVulnerabiltyChartloading = false;
      })

      .addCase(ClosedVmApplicationApi.pending, (state, action) => {
        state.closedVmAppDataLoading = true;
      })
      .addCase(ClosedVmApplicationApi.fulfilled, (state, action) => {
        state.closedVmAppData = action.payload;
        state.closedVmAppDataLoading = false;
      })
      .addCase(ClosedVmApplicationApi.rejected, (state, action) => {
        state.closedVmAppData = [];
        state.closedVmAppDataLoading = false;
      })

      .addCase(getVulnmanageTrendAPI.pending, (state, action) => {
        state.VulnTrendDataLoading = true;
      })
      .addCase(getVulnmanageTrendAPI.fulfilled, (state, action) => {
        state.VulnTrendData = action.payload;
        state.VulnTrendDataLoading = false;
      })
      .addCase(getVulnmanageTrendAPI.rejected, (state, action) => {
        state.VulnTrendData = [];
        state.VulnTrendDataLoading = false;
      })
      .addCase(vulOverviewTrend.pending, (state, action) => {
        state.VulnOverviewTrendDataLoading = true;
      })
      .addCase(vulOverviewTrend.fulfilled, (state, action) => {
        state.VulnOverviewTrendData = action.payload;
        state.VulnOverviewTrendDataLoading = false;
      })
      .addCase(vulOverviewTrend.rejected, (state, action) => {
        state.VulnOverviewTrendData = [];
        state.VulnOverviewTrendDataLoading = false;
      })

      .addCase(vulTrendOnActualForecast.pending, (state, action) => {
        state.vulTrendOnActualForecastDataLoading = true;
        state.vulTrendOnActualForecastDataError = false;
      })
      .addCase(vulTrendOnActualForecast.fulfilled, (state, action) => {
        state.vulTrendOnActualForecastData = action.payload;
        state.vulTrendOnActualForecastDataLoading = false;
        state.vulTrendOnActualForecastDataError = false;
      })
      .addCase(vulTrendOnActualForecast.rejected, (state, action) => {
        state.vulTrendOnActualForecastData = [];
        state.vulTrendOnActualForecastDataLoading = false;
        state.vulTrendOnActualForecastDataError = true;
      })

      .addCase(serverTrendOnActualForecast.pending, (state, action) => {
        state.serverTrendOnActualForecastDataLoading = true;
      })
      .addCase(serverTrendOnActualForecast.fulfilled, (state, action) => {
        state.serverTrendOnActualForecastData = action.payload;
        state.serverTrendOnActualForecastDataLoading = false;
      })
      .addCase(serverTrendOnActualForecast.rejected, (state, action) => {
        state.serverTrendOnActualForecastData = [];
        state.serverTrendOnActualForecastDataLoading = false;
      })

      .addCase(overDueVulnerabilityByPluginFamily.pending, (state, action) => {
        state.vulnerabilityByPluginFamilyDataLoading = true;
      })
      .addCase(
        overDueVulnerabilityByPluginFamily.fulfilled,
        (state, action) => {
          state.vulnerabilityByPluginFamilyData = action.payload;
          state.vulnerabilityByPluginFamilyDataLoading = false;
        }
      )
      .addCase(overDueVulnerabilityByPluginFamily.rejected, (state, action) => {
        state.vulnerabilityByPluginFamilyData = [];
        state.vulnerabilityByPluginFamilyDataLoading = false;
      })

      .addCase(overDueVulnerabilityByType.pending, (state, action) => {
        state.vulnerabilityByTypeDataLoading = true;
      })
      .addCase(overDueVulnerabilityByType.fulfilled, (state, action) => {
        state.vulnerabilityByTypeData = action.payload;
        state.vulnerabilityByTypeDataLoading = false;
      })
      .addCase(overDueVulnerabilityByType.rejected, (state, action) => {
        state.vulnerabilityByTypeData = [];
        state.vulnerabilityByTypeDataLoading = false;
      })

      .addCase(vulActionPlan.pending, (state, action) => {
        state.vulActionPlanloading = true;
      })
      .addCase(vulActionPlan.fulfilled, (state, action) => {
        state.actionPlanChart = action.payload;
        state.vulActionPlanloading = false;
      })
      .addCase(vulActionPlan.rejected, (state, action) => {
        state.actionPlanChart = [];
        state.vulActionPlanloading = false;
      })
      .addCase(summaryDrillDownList.pending, (state, action) => {
        state.summaryDrillDownLoading = true;
      })
      .addCase(summaryDrillDownList.fulfilled, (state, action) => {
        state.summaryDrillDownData = action.payload?.content || [];
        state.summaryDrillDownCount = action.payload?.totalElements || 0;
        state.summaryFirstSeenDate = action.payload?.firstSeenDate || false;
        state.summaryFirstLoggedDate = action.payload?.firstLoggedDate || false;
        state.summaryDrillDownLoading = false;
      })
      .addCase(summaryDrillDownList.rejected, (state, action) => {
        state.summaryDrillDownData = [];
        state.summaryDrillDownCount = 0;
        state.summaryDrillDownLoading = false;
      })
      .addCase(summaryPluginDrillDown.pending, (state, action) => {
        state.summaryPluginDrillDownLoading = true;
      })
      .addCase(summaryPluginDrillDown.fulfilled, (state, action) => {
        state.summaryPluginDrillDownData = action.payload;
        state.summaryPluginDrillDownLoading = false;
      })
      .addCase(summaryPluginDrillDown.rejected, (state, action) => {
        state.summaryPluginDrillDownData = [];
        state.summaryPluginDrillDownLoading = false;
      })
      .addCase(getOverdueIpListByMonth.pending, (state) => {
        state.overdueIpListDataLoading = true;
      })
      .addCase(getOverdueIpListByMonth.fulfilled, (state, action) => {
        state.overdueIpListData = action.payload;
        state.overdueIpListDataLoading = false;
      })
      .addCase(getOverdueIpListByMonth.rejected, (state) => {
        state.overdueIpListData = [];
        state.overdueIpListDataLoading = false;
      });
  },
});

export const { resetVulnerabilityData, setDisabledCategories, resetPluginDrillDown } =
  summarySlice.actions;
export default summarySlice.reducer;
